export enum ResponseStep {
    Initial = 'Initial',
    ResumeSelect = 'ResumeSelect',
    Letter = 'Letter',
    Done = 'Done',
}
